import { action } from "typesafe-actions";
import { Category } from "@models/category";
import {RequestData} from "@models/axios";
import {Video} from "@models/video-content";


export const enum CategoriesActionTypes {
    FETCH_REQUEST = "@@categories/FETCH_REQUEST",
    FETCH_SUCCESS = "@@categories/FETCH_SUCCESS",
    FETCH_ERROR = "@@categories/FETCH_ERROR",

    DELETE_REQUEST = '@@categories/DELETE_REQUEST',
    DELETE_SUCCESS = '@@categories/DELETE_SUCCESS',
    DELETE_ERROR = '@@categories/DELETE_ERROR',

    CREATE_REQUEST = '@@categories/CREATE_REQUEST',
    CREATE_SUCCESS = '@@categories/CREATE_SUCCESS',
    CREATE_ERROR = '@@categories/CREATE_ERROR',

    UPDATE_REQUEST = '@@categories/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@categories/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@categories/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@categories/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@categories/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@categories/FETCH_ITEM_ERROR',
}

export const fetchRequest = (data: {}) => action(CategoriesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Category[]) => action(CategoriesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(CategoriesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(CategoriesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(CategoriesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(CategoriesActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(CategoriesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data:RequestData) => action(CategoriesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(CategoriesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(CategoriesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data:RequestData) => action(CategoriesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(CategoriesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(CategoriesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Video[]) => action(CategoriesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(CategoriesActionTypes.FETCH_ITEM_ERROR, message);